module.exports = __webpack_public_path__ + "static/media/25.d01f6cd7.mp3";